import styled from 'styled-components';
import { 
    BaseContainer, 
    BaseTitle, 
    BaseIconContainer, 
    BaseButtonContainer, 
    BaseErrorText 
} from '../masterBase/styles';

export const ErrorMaster = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0; 
  background: rgb(255 0 0 / 50%);
  width:100vw;
  height:100vh;
`;

// Using base components with error variant
export const ErroContainer = BaseContainer;
export const Title = BaseTitle;
export const IconContainer = BaseIconContainer;
export const ButtonContainer = BaseButtonContainer;
export const Text = BaseErrorText;



